import React, {FC} from "react"

import {InjectIntl, injectIntl} from "@irati/utils/lang"
import {SSO_TYPE_SAML, SSO_TYPE_NONE} from "@irati/sso/constants/signUpOptions"
import {Tenant} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import {Body} from "@irati/ui/src/Typography"

import getEmployeeName from "@irati/admin/helpers/getEmployeeName"
import SignUpOption from "../../../components/Settings/CompanySignUpSettings/SelfSignUp/SignUpOption"
import SAMLSingleSignOn from "../../../components/Settings/CompanySignUpSettings/SAMLSingleSignOn"
import SAMLDeactivated from "../../../components/Settings/CompanySignUpSettings/SAMLSingleSignOn/SAMLDeactivated"

interface Props extends InjectIntl {
  userTenant: Tenant
  ssoButtonText: string
  handleSave: () => void
  activeOption: string
  savedOption: string
  onClick: (SSOType: string) => void
}

const SignUpOptions: FC<Props> = (props) => {
  const {formatMessage} = props

  if (props.savedOption === SSO_TYPE_NONE) {
    return <Body marginTop={1}>{formatMessage({id: "admin.containers.signUpOptions.disabledMessage"})}</Body>
  }

  return (
    <Flex direction="column" marginTop={4}>
      <SignUpOption
        title={formatMessage({id: "admin.containers.signUpOptions.signUpOptionOne.title"})}
        description={formatMessage({id: "admin.containers.signUpOptions.signUpOptionOne.description"})}
        onClick={() => props.onClick(SSO_TYPE_NONE)}
        active={props.activeOption === SSO_TYPE_NONE}>
        <SAMLDeactivated userTenant={props.userTenant} handleSave={props.handleSave} />
      </SignUpOption>
      <SignUpOption
        title={formatMessage({id: "admin.containers.signUpOptions.signUpOptionTwo.title"})}
        description={formatMessage({id: "admin.containers.signUpOptions.signUpOptionTwo.description"}, {employeeName: getEmployeeName()})}
        onClick={() => props.onClick(SSO_TYPE_SAML)}
        active={props.activeOption === SSO_TYPE_SAML}>
        <SAMLSingleSignOn ssoButtonText={props.ssoButtonText} userTenant={props.userTenant} handleSave={props.handleSave} />
      </SignUpOption>
    </Flex>
  )
}

export default injectIntl(SignUpOptions)
